import { GridType } from "../../../../Entities/GridType";
import { DraftProjectCapacity } from "./DraftProjectCapacity";

export const DraftRequestView = () => {
	return <DraftProjectCapacity gridType={GridType.Request} />
}